<template>
  <div class="c-card-header">
    <span class="c-card-header__text"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
};
</script>

<style lang="scss" scoped>
.c-card-header {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  position: relative;
  padding-left: 10px;
  font-weight: bold;
  &::before {
    content: '';
    width: 3px;
    height: 16px;
    background: #1890FF;
    border-radius: 3px;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    position: absolute;
  }
  &__text {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 13px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 6px;
      left: 0;
      bottom: 3px;
    }
  }
}
</style>
